import { useCustomerData } from '@cinch-labs/customer-data-segment'
import { sendDigitalDataEvent } from '@cinch-nx/shared-analytics'

import styles from './winter-sale.module.css'

export function WinterSaleBanner() {
  const { trackEvent } = useCustomerData()
  const handleOnClick = () => {
    const data = {
      event: {
        name: 'click',
        category: 'winter flash sale',
        action: 'shop cars on offer',
        label: 'hero',
      },
    }
    trackEvent({
      type: 'track',
      eventName: 'Promotion Clicked',
      data: {
        name: 'Winter sale promo banner - cars on offer',
        position: 'top banner',
      },
    })
    sendDigitalDataEvent(data)
  }
  return (
    <>
      <span className={styles.saveTag}>SAVE</span>
      <p className={styles.text}>
        Save up to <b>£1000</b> on{' '}
        <a href="/find-vehicle?tags=cars-on-offer" onClick={handleOnClick}>
          selected cars
        </a>
        . Discount varies by car.{' '}
        <a href="/policies/winter-sale">T&Cs apply.</a>
      </p>
    </>
  )
}

export default WinterSaleBanner
